(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["playecom-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pe-video-library')) {
  customElements.define('pe-video-library', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const select = this.querySelector('[data-video-filter]');
      if (!select) return;
      const cards = [...this.querySelectorAll('[data-video-topic]')];
      const topics = [...new Set(cards.map((card) => card.dataset.videoTopic).filter(Boolean))].sort((a,b) => a.localeCompare(b));
      topics.forEach((topic) => select.add(new Option(topic, topic)));
      if (topics.length > 1) this.querySelector('[data-video-toolbar]').hidden = false;
      select.addEventListener('change', () => {
        let count = 0;
        cards.forEach((card) => {
          card.hidden = !!select.value && card.dataset.videoTopic !== select.value;
          if (!card.hidden) count++;
          else {
            card.querySelectorAll('pe-video').forEach((player) => player.stop?.());
          }
        });
        this.querySelector('[data-video-empty]').hidden = count !== 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
